import elementIsNotNULL from './elementIsNotNULL';

const hideElement = function (element) {
    if (!element) return;
    if (typeof element === 'string') {
        element = document.getElementById(element);
    }
    if (elementIsNotNULL(element)) {
        element.style.display = 'none';
    }
};
export default hideElement;
